import { z } from 'zod';

const dashboardResponseSchemas = {
  getReport: {
    orders: z.object({
      success: z.boolean(),
      message: z.string(),
      data: z.array(
        z.object({
          orderId: z.number(),
          orderDate: z.string().datetime(),
          ordertype: z.string(),
          companyName: z.string(),
          orderNumber: z.string(),
          orderedBy: z.string(),
          orderedSims: z.number(),
        })
      ),
    }),
  },
  getRecentEsimOrders: z.object({
    success: z.boolean(),
    message: z.string(),
    data: z.object({
      totalOrders: z.number(),
      ordersArray: z.array(
        z.object({
          ordertype: z.string(),
          status: z.number(),
          orderId: z.number(),
          userId: z.number(),
          orderDate: z.string().datetime(),
          companyName: z.string(),
          orderNumber: z.string(),
          orderedBy: z.string(),
          orderedSims: z.number(),
        })
      ),
    }),
  }),
  getRecentPSimOrders: z.object({
    success: z.boolean(),
    message: z.string(),
    data: z.object({
      totalOrders: z.number(),
      ordersArray: z.array(
        z.object({
          ordertype: z.string(),
          status: z.number(),
          orderId: z.number(),
          userId: z.number(),
          orderDate: z.string().datetime(),
          companyName: z.string(),
          orderNumber: z.string(),
          orderedBy: z.string(),
          orderedSims: z.number(),
        })
      ),
    }),
  }),
} as const;

export default dashboardResponseSchemas;
